import { Bmi, BmiApi, ServiceCodesEnum } from '@types-lib';

export const EMPTY_BMI_GET_RESPONSE: BmiApi.UserBiometricsResponse = {
  pagination: {
    total: 0,
    limit: 0,
    offset: 0,
    service_codes: null,
    order: 'desc',
  },
  data: {
    treatment_details: {
      bmi_id: undefined,
      mail_order_fill_request_id: 0,
      start_date: '1985-01-01',
      start_weight: undefined,
      current_wei_medication: undefined,
      order_id: 0,
      status: null,
    },
    list: [],
  },
};

export const USER_BMI_MOCK_RESPONSE: BmiApi.UserBiometricsResponse = {
  pagination: {
    total: 2,
    limit: 2,
    offset: 0,
    service_codes: null,
    order: 'desc',
  },
  data: {
    treatment_details: {
      bmi_id: 98765,
      mail_order_fill_request_id: 12345,
      start_date: '2024-02-21',
      start_weight: 100,
      current_wei_medication: {
        code: 'med_code',
        name: 'med_name',
        order_id: 9876,
        medical_name: 'medical_name',
        last_wei_created: '2025-02-27', // last wei row creation date
        weight: '100',
      },
      order_id: 54321,
      status: Bmi.FivePercentWeightLossStatusEnum.NOT_MET,
    },
    list: [
      {
        id: 0,
        user_id: 0,
        order: {
          mail_order_fill_request_id: 0,
          service_code: ServiceCodesEnum.HAY_F_HAYFEVER_TREATMENT,
          order_id: 12345,
          is_refill: false,
        },
        height: 145.0,
        weight: 60.0,
        bmi: 28.5,
        created: '2024-09-04T10:55:22.000000Z',
        modified: '2024-09-05T10:55:22.000000Z',
        note: '',
        is_active: 0,
      },
      {
        id: 1,
        user_id: 1,
        order: {
          mail_order_fill_request_id: 1,
          service_code: ServiceCodesEnum.WEI_F_WEIGHT_LOSS_TREATMENT,
          order_id: 12345,
          is_refill: true,
        },
        height: 170.0,
        weight: 95.0,
        five_percent_weight_check: -5,
        bmi: 20.0,
        created: '2024-09-02T10:55:22.000000Z',
        modified: '2024-09-02T10:55:22.000000Z',
        note: '',
        is_active: 0,
      },
    ],
  },
};

export const BMI_STORE_MOCK: Bmi.BmiStoreState = {
  treatmentDetails: USER_BMI_MOCK_RESPONSE.data.treatment_details,
  patientUserId: 1234789,
  itemBeingEditedId: null,
  bmiItemEntities: [],
  bmiItemEntityMap: {},
  bmiItemIds: [],
  bmiListOptions: {
    pagination: {
      // BE pagination as future possibility
      total: 2,
      limit: 300,
      offset: 0,
      service_codes: null,
      order: 'desc',
    },
    filterBy: { serviceCodes: [] },
    sort: 'desc',
  },
};

export const BMI_ITEM_ENTITIES_ARRAY: BmiApi.UserBMI[] = [
  {
    ...USER_BMI_MOCK_RESPONSE.data.list[0],
  },
  {
    ...USER_BMI_MOCK_RESPONSE.data.list[1],
  },
];

export const BMI_DIALOG_DATA: Bmi.BMIDialogData = {
  patientId: 1,
  visitId: 100,
};
